import React, { useEffect,useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { comptabiliteActions } from '../reducer/comptabilite'
import { RingLoader } from 'react-spinners'
import { IoIosArrowDropleftCircle } from "react-icons/io";
import {useNavigate} from 'react-router-dom'
import { AiFillCloseCircle } from "react-icons/ai";
import moment from 'moment'
import 'moment/min/locales'
export default function BilanComponent({retour,id}) {
    const dispatch =useDispatch()
    const navigate =useNavigate()
    const [chargement,setChargement]=useState(false)
  useEffect(() => { 
    dispatch(comptabiliteActions.voirByIdBilan(id))
  },[])
  
  const {isLoader,bilan,resultat} = useSelector((state)=>{
    return state.comptabiliteReducer
   });
    const cloturer=()=>{
        setChargement(true)
        dispatch(comptabiliteActions.cloturer({id:id,resultat:resultat}))
        setChargement(false)
    }
     console.log("corps:",bilan,resultat)
  return (
   <div className='z-10 absolute top-[100px] left-[20px] mx-3 bg-white w-[300px]  border p-3  border-gray-100  rounded-md '>
   <div className='absolute right-0 top-0 m-1 cursor-pointer  z-50 '>    
            <AiFillCloseCircle color="gray" size={25} onClick={()=>retour()} />
           </div>
       {(isLoader===true||bilan===null)?<div className='w-full flex justify-center items-center mt-10 '> 
                 <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                     <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                 </svg>
             </div>:<> 
            
        <div  className='flex  flex-col justify-start w-full mb-3'>
            
              <div className='text-lg font-bold'>
              Bilan financier
              </div>
         
              <span className='tracking-wide text-sm text-gray-300 font-medium'>Mois:{bilan.periode} </span>
              <span 
                   className={`${bilan.statut==='cloturé'?'text-red-400':'text-green-400'}
                              tracking-wide text-sm  font-medium mt-1
                              `}>
                              {bilan.statut} 
                               </span>
         </div>
            
      <table className='w-full mb-3'>
            
       <tbody>
         <tr className=' odd:bg-gray-100  bg-white rounded-3xl h-14 m-2  items-center w-full  cursor-pointer'>
           <td className='font-medium text-base text-gray-500 text-start'>Recettes</td>
           <td className='font-medium text-base text-gray-500 text-center'>{bilan.recette} </td>
         </tr>
         <tr className=' odd:bg-gray-100  bg-white rounded-3xl h-14 m-2  items-center w-full  cursor-pointer'>
           <td className='font-medium text-base text-gray-500 text-start'>Charges</td>
           <td className='font-medium text-base text-gray-500 text-center'>{bilan.charge}</td>
         </tr>
       </tbody>
       <tfoot>
         <tr  className='bg-red-100 rounded-3xl h-14 m-2  items-center w-full  cursor-pointer'>
           <td className='font-bold text-base text-red-500 text-start'>Resultat</td>
           <td className='font-medium text-base text-gray-500 text-center'>{bilan.resultat||resultat} </td>
         </tr>
       </tfoot>
    
      </table>
     <div className='w-full items-center flex justify-end'>
             <span className='text-end text-xs text-gray-400'> {moment(`${bilan.updatedAt}`).locale('fr').fromNow()}</span> 
        </div>
 <div classeName='flex flex-col  '>

   {bilan.statut!=='cloturé'&&
            <>                       
  {chargement===false?<button 
       type="button" 
       onClick={()=>cloturer()} 
       className="text-blue-700 font-medium  text-md w-full justiify-center px-5 py-2.5 text-center inline-flex items-center"
        >
       Cloturer
   </button>:<span className='flex flex-row items-center space-x-2 justify-center inline-flex items-center px-3 py-2 text-md font-medium text-center text-blue-700'>
       <svg aria-hidden="true" className="w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                     <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                 </svg>
              Loading...
           </span>}</>
           
}
           </div>
    
          
   </>}
      </div>
  )
}
